import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PromotionAction } from 'src/app/models/promotionAction.model';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { PromotionDetailDialogComponent } from '../promotion-detail-dialog/promotion-detail-dialog.component';

@Component({
    selector: 'header-content-task',
    templateUrl: './header-content-task.component.html',
    styleUrl: './header-content-task.component.scss',
    standalone: false
})
export class HeaderContentTaskComponent {
  @Input() isCurrentPromotion: boolean = false;
  // used when isCurrentPromotion is true
  @Input() profile?: StreApperInfo; 
  // used when isCurrentPromotion is false
  @Input() completedTaskIds?: string[]; 

  @Input() promotionAction: PromotionAction;
  @Input() availableTaskIds: string[];
  @Input() spotsReceived: number;

  constructor(
    private readonly dialog: MatDialog
  ) {}

  isTaskCompleted(taskId: string): boolean {
    if(!this.isCurrentPromotion) {
      return this.completedTaskIds?.some(
        (completedTaskId) => completedTaskId === taskId
      ) ?? false;
    }

    return this.profile.completedSebbieTasks?.some(
      (completedTask) => completedTask.id === taskId
    ) ?? false;
  }

  openPromotionDialog(): void {
    this.dialog.open<PromotionDetailDialogComponent>(PromotionDetailDialogComponent, {
      autoFocus: false, // To prevent select state of close button in header
      data: {
        promotionAction: this.promotionAction,
      }
    });
  }
}
